export default [
  {
    path: "/NOLOGIN",
    name: 'NOLOGIN',
    component: () => import("./index.vue"),
  }
]



// WEBPACK FOOTER //
// ./src/views/401/index.js